import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import { TicketZigZag } from '../../../../../lotteries/TicketZigZag/TicketZigZag';

type BenefitPodProps = ComponentProps<'div'> & {
  title: string;
};

/**
 * BenefitPod component displays a single benefit card with title, description and decorative icon.
 * Uses the TicketZigZag component for the decorative elements.
 *
 * @param {string} title - The title of the benefit
 * @param {string} [className] - Optional CSS classes to apply to container
 * @returns {JSX.Element} The rendered BenefitPod component
 */
function BenefitPod({ title, className, ...props }: BenefitPodProps) {
  return (
    <div className={twMerge('relative rounded-lg border border-border p-3 flex flex-col gap-2.5', className)} {...props}>
      <div className="flex flex-col gap-2.5 flex-1">
        <p className="paragraph-explanatory-strong z-10">{title}</p>
      </div>

      <div className="absolute bottom-0 right-0 flex items-center justify-center">
        <TicketZigZag />
      </div>
    </div>
  );
}

export { BenefitPod };
